import { http } from "./httpServices";
import { NOTIFICATION } from "./constants";

export function postNotification(data: { body: string; title: string }) {
  return http.post(NOTIFICATION, data);
}

export function listNotificationsWithPagination(page: number, limit: number) {
  return http.get(`${NOTIFICATION}?page=${page}&limit=${limit}`);
}

export function getNotificationDeeplinkType(type: string) {
  return http.get(`/events/dropdown`, { params: { type } });
}
